/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

export default basePropertyOf;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_basePropertyOf.js
// module id = 313
// module chunks = 0